import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  { question: 'E-fatura zorunluluğu için ciro sınırı ne kadar? (2026)', answer: '2026 yılı itibarıyla yıllık brüt satış hasılatı 3 milyon TL ve üzerinde olan mükellefler e-fatura uygulamasına geçmek zorundadır. Bu sınır her yıl yeniden değerleme oranında güncellenmektedir.' },
  { question: 'E-fatura geçişi nasıl yapılır?', answer: 'GİB (Gelir İdaresi Başkanlığı) portalı üzerinden başvuru yapılır. Özel entegratör veya GİB portalı yöntemi seçilir. Teknik altyapı kurulur ve test sürecinden geçilir. Tüm süreç yaklaşık 2–4 hafta sürer.' },
  { question: 'E-fatura ile e-arşiv faturası arasındaki fark nedir?', answer: 'E-fatura, e-fatura mükellefleri arasında elektronik ortamda düzenlenir ve iletilir. E-arşiv faturası ise e-fatura mükellefi olmayan alıcılara veya bireysel tüketicilere düzenlenir.' },
  { question: 'E-faturaya geçmeden önce ne yapılmalı?', answer: 'Muhasebe yazılımınızın e-fatura uyumlu olup olmadığı kontrol edilmeli, özel entegratör seçimi yapılmalı ve GİB\'e başvuru tamamlanmalıdır. Mali müşavirinizle koordineli ilerlemeniz önerilir.' },
  { question: 'E-fatura zorunluluğuna uymayanlara ceza var mı?', answer: 'Evet. E-fatura zorunluluğuna uymayan mükellefler için Vergi Usul Kanunu kapsamında özel usulsüzlük cezası uygulanmaktadır. 2026 yılı ceza tutarları için güncel mevzuata bakılmalıdır.' },
  { question: 'E-fatura sistemine geçiş maliyeti ne kadar?', answer: 'Özel entegratör kullanımı yıllık 1.500–5.000 TL arasında değişmektedir. GİB portalı üzerinden ücretsiz kullanım da mümkündür ancak yoğun fatura hacmi için entegratör tercih edilmesi önerilir.' },
];

const obligatoryGroups = [
  { icon: 'ri-store-line', title: 'Ciro Sınırını Aşanlar', desc: 'Yıllık brüt satış hasılatı 3 milyon TL ve üzerinde olan mükellefler' },
  { icon: 'ri-truck-line', title: 'İnternet Satıcıları', desc: 'Elektronik ticaret yapan ve belirli ciro sınırını aşan işletmeler' },
  { icon: 'ri-gas-station-line', title: 'Akaryakıt Sektörü', desc: 'Akaryakıt dağıtım ve satış işletmeleri' },
  { icon: 'ri-hotel-line', title: 'Konaklama Sektörü', desc: 'Otel, pansiyon ve konaklama tesisleri' },
  { icon: 'ri-car-line', title: 'Araç Kiralama', desc: 'Araç kiralama ve satış işletmeleri' },
  { icon: 'ri-building-2-line', title: 'İnşaat Sektörü', desc: 'Belirli büyüklükteki inşaat ve müteahhitlik firmaları' },
];

const steps = [
  { num: '01', title: 'GİB Başvurusu', desc: 'Gelir İdaresi Başkanlığı portalına giriş yaparak e-fatura başvurusu tamamlanır.' },
  { num: '02', title: 'Entegratör Seçimi', desc: 'GİB portalı veya özel entegratör yöntemi seçilir. İhtiyaca göre karar verilir.' },
  { num: '03', title: 'Teknik Kurulum', desc: 'Muhasebe yazılımı entegrasyonu ve teknik altyapı kurulumu yapılır.' },
  { num: '04', title: 'Test Süreci', desc: 'Sistem test edilir, hatalı fatura gönderimi önlenir.' },
  { num: '05', title: 'Canlıya Geçiş', desc: 'Onay alındıktan sonra gerçek faturalar elektronik ortamda düzenlenmeye başlanır.' },
];

export default function EFaturaKimlerIcinZorunluPage() {
  useEffect(() => {
    window.scrollTo({ top: 0 });

    document.title = 'E-Fatura Kimler İçin Zorunlu? 2026 Ciro Sınırı ve Geçiş Rehberi | Özgür Çakmak SMMM';

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };

    setMeta('description', 'E-fatura kimler için zorunlu? 2026 yılı ciro sınırı 3 milyon TL. Zorunluluk kapsamındaki mükellefler, e-faturaya geçiş adımları ve dikkat edilmesi gereken noktalar bu rehberde.');
    setMeta('keywords', 'e-fatura kimler için zorunlu, e-fatura ciro sınırı 2026, e-faturaya geçiş, e-arşiv fatura zorunluluğu, GİB e-fatura başvuru');
    setMeta('og:title', 'E-Fatura Kimler İçin Zorunlu? 2026 Güncel Rehber', true);
    setMeta('og:description', '2026 e-fatura zorunluluk kapsamı, 3 milyon TL ciro sınırı ve geçiş süreci adım adım anlatılıyor.', true);
    setMeta('og:type', 'article', true);
    setMeta('og:url', 'https://ozgurcakmak.com.tr/e-fatura-kimler-icin-zorunlu', true);

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) { canonical = document.createElement('link'); canonical.setAttribute('rel', 'canonical'); document.head.appendChild(canonical); }
    canonical.setAttribute('href', 'https://ozgurcakmak.com.tr/e-fatura-kimler-icin-zorunlu');

    const existingSchema = document.getElementById('faq-schema-efatura');
    if (existingSchema) existingSchema.remove();
    const script = document.createElement('script');
    script.id = 'faq-schema-efatura';
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      'mainEntity': faqs.map((f) => ({
        '@type': 'Question',
        'name': f.question,
        'acceptedAnswer': { '@type': 'Answer', 'text': f.answer },
      })),
    });
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('faq-schema-efatura');
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <InfoNavbar />

      <section className="relative pt-20 min-h-[420px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://public.readdy.ai/ai/img_res/b4bdb206f6d92073e7c1ec84d42184ff.jpg" alt="E-Fatura Kimler İçin Zorunlu" className="w-full h-full object-cover object-top" loading="eager" decoding="async" />
          <div className="absolute inset-0 bg-[#0A2540]/50"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-16 w-full">
          <nav className="flex items-center gap-2 mb-5" aria-label="breadcrumb">
            <Link to="/" className="text-white/50 text-xs hover:text-white/80 transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line text-white/30 text-xs"></i>
            <span className="text-white/70 text-xs">E-Fatura Kimler İçin Zorunlu?</span>
          </nav>
          <div className="flex flex-wrap gap-2 mb-5">
            {['2026 Güncel', 'Zorunluluk', 'Ciro Sınırı', 'Nasıl Geçilir', 'Şartları'].map((kw) => (
              <span key={kw} className="px-3 py-1 bg-white/10 border border-white/20 text-white/80 text-xs rounded-full">{kw}</span>
            ))}
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 max-w-2xl leading-tight">E-Fatura Kimler İçin Zorunlu?</h1>
          <p className="text-white/70 text-base md:text-lg max-w-xl leading-relaxed mb-8">Zorunluluk kapsamındaki mükellefler, ciro sınırları ve geçiş süreci 2026 güncel bilgileriyle.</p>
          <div className="flex flex-wrap gap-3">
            <a href="#iletisim-cta" onClick={(e) => { e.preventDefault(); document.getElementById('iletisim-cta')?.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 py-3 bg-white text-[#0A2540] text-sm font-semibold rounded-xl hover:-translate-y-0.5 transition-all cursor-pointer whitespace-nowrap">Bilgi Al</a>
            <a href="https://wa.me/905300953230" target="_blank" rel="nofollow noreferrer" className="px-6 py-3 bg-[#25D366] text-white text-sm font-semibold rounded-xl hover:-translate-y-0.5 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"><i className="ri-whatsapp-line"></i>WhatsApp</a>
          </div>
        </div>
      </section>

      <section className="py-14 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <p className="text-gray-600 text-base leading-relaxed text-center">
            <strong>E-fatura</strong> uygulaması, Türkiye'de belirli ciro sınırlarını aşan mükellefler için zorunlu hale getirilmiştir. 2026 yılı itibarıyla güncel zorunluluk kapsamı, geçiş süreci ve dikkat edilmesi gereken noktalar bu rehberde açıklanmaktadır. Durumunuza özel bilgi almak için iletişime geçebilirsiniz.
          </p>
        </div>
      </section>

      <section className="py-14 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <span className="text-xs font-semibold tracking-widest text-[#0A2540]/50 uppercase">Zorunluluk Kapsamı</span>
            <h2 className="text-2xl md:text-3xl font-bold text-[#0A2540] mt-3">Kimler E-Fatura Kullanmak Zorunda?</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {obligatoryGroups.map((g, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#0A2540]/5 rounded-xl flex-shrink-0"><i className={`${g.icon} text-[#0A2540] text-lg`}></i></div>
                <div><h3 className="text-[#0A2540] font-semibold text-sm mb-1">{g.title}</h3><p className="text-gray-500 text-xs leading-relaxed">{g.desc}</p></div>
              </div>
            ))}
          </div>
          <div className="mt-8 bg-[#0A2540] rounded-2xl p-6 text-center">
            <p className="text-white font-semibold text-sm mb-1">2026 Ciro Sınırı</p>
            <p className="text-white/70 text-xs">Yıllık brüt satış hasılatı <strong className="text-white">3.000.000 TL</strong> ve üzerinde olan mükellefler e-fatura uygulamasına dahil olmak zorundadır.</p>
          </div>
        </div>
      </section>

      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <span className="text-xs font-semibold tracking-widest text-[#0A2540]/50 uppercase">Geçiş Süreci</span>
            <h2 className="text-2xl md:text-3xl font-bold text-[#0A2540] mt-3">E-Faturaya Nasıl Geçilir?</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {steps.map((step, i) => (
              <div key={i} className="bg-[#F5F7FA] rounded-2xl p-5 border border-gray-100">
                <div className="text-3xl font-black text-[#0A2540]/8 mb-2">{step.num}</div>
                <h3 className="text-[#0A2540] font-semibold text-sm mb-2">{step.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 bg-[#F5F7FA]">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <span className="text-xs font-semibold tracking-widest text-[#0A2540]/50 uppercase">SSS</span>
            <h2 className="text-2xl md:text-3xl font-bold text-[#0A2540] mt-3">Sık Sorulan Sorular</h2>
          </div>
          <FAQAccordion faqs={faqs} />
        </div>
      </section>

      <SoftCTA />
      <div id="iletisim-cta"><ContactCTA /></div>
      <InfoFooter />
      <a href="https://wa.me/905300953230" target="_blank" rel="nofollow noreferrer" className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-[#25D366] text-white rounded-full cursor-pointer hover:scale-110 transition-transform" aria-label="WhatsApp"><i className="ri-whatsapp-line text-2xl"></i></a>
    </div>
  );
}

function FAQAccordion({ faqs }: { faqs: { question: string; answer: string }[] }) {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <div className="space-y-3">
      {faqs.map((faq, i) => (
        <div key={i} className="border border-gray-200 rounded-xl overflow-hidden">
          <button className="w-full flex items-center justify-between px-6 py-4 text-left bg-white hover:bg-[#F5F7FA] transition-colors cursor-pointer" onClick={() => setOpen(open === i ? null : i)}>
            <span className="text-[#0A2540] font-medium text-sm pr-4">{faq.question}</span>
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0"><i className={`text-[#0A2540] text-base ${open === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i></div>
          </button>
          {open === i && <div className="px-6 py-4 bg-[#F5F7FA] border-t border-gray-100"><p className="text-gray-600 text-sm leading-relaxed">{faq.answer}</p></div>}
        </div>
      ))}
    </div>
  );
}

function SoftCTA() {
  return (
    <section className="py-10 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#0A2540]/5 rounded-full mb-4"><i className="ri-information-line text-[#0A2540] text-sm"></i><span className="text-[#0A2540] text-xs font-medium">Bilgilendirme</span></div>
        <p className="text-gray-600 text-sm leading-relaxed">Bu sayfadaki bilgiler genel rehber niteliğindedir. Durumunuza özel bilgi almak için iletişime geçebilirsiniz.</p>
      </div>
    </section>
  );
}

function ContactCTA() {
  const [form, setForm] = useState({ name: '', phone: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.message || form.message.length > 500) return;
    setStatus('loading');
    try {
      const body = new URLSearchParams({ name: form.name, phone: form.phone, message: form.message });
      const res = await fetch('https://readdy.ai/api/form/d7c144qqofe8vli40s7g', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
      if (res.ok) { setStatus('success'); setForm({ name: '', phone: '', message: '' }); } else setStatus('error');
    } catch { setStatus('error'); }
  };
  return (
    <section className="py-20 bg-[#0A2540]">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-xs font-semibold tracking-widest text-[#60A5FA] uppercase">Ücretsiz Danışmanlık</span>
            <h2 className="text-2xl md:text-3xl font-bold text-white mt-3 mb-4">Durumunuza Özel Bilgi Alın</h2>
            <p className="text-white/60 text-sm leading-relaxed mb-6">E-fatura geçiş sürecinizde yanınızdayız.</p>
            <div className="flex flex-col gap-3">{[{ icon: 'ri-phone-line', text: '0 530 095 32 30' }, { icon: 'ri-mail-line', text: 'info@ozgurcakmak.com.tr' }, { icon: 'ri-time-line', text: 'Pzt–Cum: 09:00–18:00' }].map((item) => (<div key={item.text} className="flex items-center gap-3"><div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-lg"><i className={`${item.icon} text-white text-sm`}></i></div><span className="text-white/70 text-sm">{item.text}</span></div>))}</div>
          </div>
          <form onSubmit={handleSubmit} data-readdy-form id="efatura-contact-form" className="bg-white/5 border border-white/10 rounded-2xl p-6 flex flex-col gap-4">
            <div><label className="text-white/60 text-xs mb-1.5 block">Ad Soyad</label><input type="text" name="name" value={form.name} onChange={handleChange} required placeholder="Adınız Soyadınız" className="w-full bg-white/10 border border-white/15 text-white placeholder-white/30 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-white/40 transition-colors" /></div>
            <div><label className="text-white/60 text-xs mb-1.5 block">Telefon</label><input type="tel" name="phone" value={form.phone} onChange={handleChange} required placeholder="+90 5XX XXX XX XX" className="w-full bg-white/10 border border-white/15 text-white placeholder-white/30 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-white/40 transition-colors" /></div>
            <div>
              <div className="flex justify-between mb-1.5"><label className="text-white/60 text-xs">Mesajınız</label><span className="text-white/30 text-xs">{form.message.length}/500</span></div>
              <textarea name="message" value={form.message} onChange={handleChange} required maxLength={500} rows={4} placeholder="Danışmak istediğiniz konu..." className="w-full bg-white/10 border border-white/15 text-white placeholder-white/30 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-white/40 transition-colors resize-none"></textarea>
            </div>
            {status === 'success' && <div className="flex items-center gap-2 p-3 bg-emerald-500/20 border border-emerald-500/30 rounded-lg"><i className="ri-checkbox-circle-line text-emerald-400"></i><span className="text-emerald-300 text-sm">Mesajınız iletildi.</span></div>}
            {status === 'error' && <div className="p-3 bg-rose-500/20 border border-rose-500/30 rounded-lg"><span className="text-rose-300 text-sm">Bir hata oluştu.</span></div>}
            <button type="submit" disabled={status === 'loading' || form.message.length > 500} className="w-full py-3 bg-white text-[#0A2540] text-sm font-semibold rounded-lg hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60">{status === 'loading' ? 'Gönderiliyor...' : 'Mesaj Gönder'}</button>
          </form>
        </div>
      </div>
    </section>
  );
}

function InfoNavbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => { const h = () => setScrolled(window.scrollY > 40); window.addEventListener('scroll', h); return () => window.removeEventListener('scroll', h); }, []);
  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0A2540]/50 backdrop-blur-md border-b border-white/10' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/20f355b3-57c6-42af-8f1b-e19ef75cee72/a013bf3f-953f-4147-a966-2d3225ff6ac1_zgr-akmak-logo-3.png?v=001ea3c7f21fa91e8ebb91c8becb8de9"
            alt="Özgür Çakmak SMMM Logo"
            className="h-12 w-auto object-contain"
          />
        </Link>
        <div className="flex items-center gap-3">
          <Link to="/" className="text-sm font-medium text-white/90 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Ana Sayfa</Link>
          <a href="#iletisim-cta" onClick={(e) => { e.preventDefault(); document.getElementById('iletisim-cta')?.scrollIntoView({ behavior: 'smooth' }); }} className="px-5 py-2 bg-[#0A2540] text-white text-sm font-medium rounded-lg hover:-translate-y-0.5 transition-all whitespace-nowrap cursor-pointer">İletişime Geç</a>
        </div>
      </div>
    </header>
  );
}

function InfoFooter() {
  const links = [{ label: 'Şahıs Şirketi Nasıl Kurulur?', href: '/sahis-sirketi-nasil-kurulur' }, { label: 'Vergi Oranları 2026', href: '/sahis-sirketi-vergi-oranlari' }, { label: 'Limited mi Şahıs mı?', href: '/limited-mi-sahis-mi' }, { label: 'E-Fatura Zorunluluğu', href: '/e-fatura-kimler-icin-zorunlu' }, { label: 'KDV Nedir?', href: '/kdv-nedir-nasil-hesaplanir' }, { label: 'Vergi Borcu Sorgulama', href: '/vergi-borcu-sorgulama' }];
  return (
    <footer className="bg-[#F5F7FA] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-[#0A2540] rounded-lg">
                <i className="ri-bar-chart-box-line text-white text-base"></i>
              </div>
              <span className="font-bold text-[#0A2540] text-base">Özgür Çakmak SMMM</span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed">Mali süreçlerinizde güvenilir danışmanlık.</p>
          </div>
          <div><h4 className="text-[#0A2540] font-semibold text-sm mb-3">Bilgi Merkezi</h4><ul className="space-y-2">{links.map((l) => (<li key={l.href}><Link to={l.href} className="text-gray-500 text-xs hover:text-[#0A2540] transition-colors cursor-pointer">{l.label}</Link></li>))}</ul></div>
          <div><h4 className="text-[#0A2540] font-semibold text-sm mb-3">İletişim</h4><div className="space-y-2">{[{ icon: 'ri-phone-line', text: '0 530 095 32 30' }, { icon: 'ri-mail-line', text: 'info@ozgurcakmak.com.tr' }].map((item) => (<div key={item.text} className="flex items-center gap-2"><div className="w-5 h-5 flex items-center justify-center text-gray-400"><i className={`${item.icon} text-sm`}></i></div><span className="text-gray-500 text-sm">{item.text}</span></div>))}</div></div>
        </div>
      </div>
      <div className="border-t border-gray-200 bg-white"><div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2"><p className="text-gray-400 text-xs">© 2026 Özgür Çakmak SMMM. Tüm hakları saklıdır.</p><Link to="/" className="text-gray-400 text-xs hover:text-gray-600 transition-colors cursor-pointer">Ana Sayfaya Dön</Link></div></div>
    </footer>
  );
}
